import React from 'react';

interface CrunchbaseIconProps {
  size?: number;
  className?: string;
}

/**
 * Crunchbase "cb" wordmark — the REAL, official brand letterforms (from the
 * Simple Icons Crunchbase logo), with the outer rounded-square background path
 * removed. The genuine "cb" subpaths are kept verbatim from the official SVG and
 * rendered as positive fills via `evenodd` (which also preserves the "b" counter
 * as a hole) instead of being knocked out of a square. Nothing is hand-drawn.
 *
 * `currentColor` (monochrome, inherits hover). The viewBox is cropped to the
 * letters' exact bounding box (x 4.225–19.676, y 5.37–16.235; center 11.95,10.8)
 * so the mark fills its box at a weight consistent with the neighbouring icons.
 */
export const CrunchbaseIcon: React.FC<CrunchbaseIconProps> = ({ size = 20, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="3.95 2.8 16 16"
    fill="currentColor"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.045 14.465A2.11 2.11 0 0 0 9.84 13.42h1.66a3.69 3.69 0 1 1 0-1.75H9.84a2.11 2.11 0 1 0-2.795 2.795zm11.345.845a3.55 3.55 0 0 1-1.06.63 3.68 3.68 0 0 1-3.39-.38v.38h-1.51V5.37h1.5v4.11a3.74 3.74 0 0 1 1.8-.63H16a3.67 3.67 0 0 1 2.39 6.46zm-.223-2.766a2.104 2.104 0 1 1-4.207 0 2.104 2.104 0 0 1 4.207 0z"
    />
  </svg>
);

export default CrunchbaseIcon;
